import { Button, Group, Modal, Text } from '@mantine/core'
import { useForm } from '@mantine/form'
import { Tradeshow } from 'api/dto/tradeshow'
import { Visitor } from 'api/dto/visitor'
import { useSendEmailVisitor } from 'api/query/visitor'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

interface SendEmailVisitorProps {
  opened: boolean
  onClose: () => void
  visitor?: Visitor
}

export function SendEmailVisitor({ visitor, opened, onClose }: SendEmailVisitorProps) {
  const { t } = useTranslation()
  const { tradeshowId } = useParams()
  const form = useForm<Tradeshow>({})
  const { mutateAsync: sendEmail } = useSendEmailVisitor(tradeshowId!)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    if (!opened) {
      form.reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [opened])

  async function onSubmit() {
    if (!visitor?.id) {
      return
    }

    setSubmitting(true)
    await sendEmail(visitor.id)
    setSubmitting(false)
    onClose()
  }

  return (
    <Modal size="lg" opened={opened} onClose={onClose} title={t('visitor.send-email')}>
      <form onSubmit={form.onSubmit(onSubmit)}>
        <Text size="15px">{t('visitor.email-are-you-sure-visitor', { replace: { name: visitor?.fullName } })}</Text>

        <Group mt={30} position="right">
          <Button disabled={submitting} variant="outline" size="xs" color="red" onClick={onClose}>
            {t('common.cancel')}
          </Button>

          <Button loading={submitting} size="xs" variant="outline" color="green" type="submit">
            {t('common.send')}
          </Button>
        </Group>
      </form>
    </Modal>
  )
}
